import { defineAsyncComponent } from 'vue';
import { Permission } from '@shared/infrastructure/auth/permission.js';
import type { AppModule } from '@shared/presentation/router/composition.js';
import { VP_SECTION_NAV } from '../presentation/section-nav.js';

/**
 * `video-detail` feature of Virtual Profiler.
 *
 * HU-33 a HU-36. Not in the sidebar: it is reached from the dataset or from a
 * group, always about a video somebody picked. A menu entry would have nothing to
 * open.
 *
 * Which run is being looked at travels as `?run=`, not in the path: it is a view of
 * the same video rather than a different resource, and the link an operator shares
 * has to point at the run they were looking at.
 *
 * The whole review opens only from the gallery. Picked anywhere else, a video opens in
 * the peek panel instead (`lib/peek.ts`), an overlay the shell renders on every screen.
 */
export const virtualProfilerVideoDetailModule: AppModule = {
  name: 'virtual-profiler-video-detail',
  routes: [],
  overlays: [defineAsyncComponent(() => import('./presentation/VideoPeek.vue'))],
  layoutRoutes: [
    {
      path: 'virtual-profiler/data/videos/:videoId',
      name: 'virtual-profiler-video-detail',
      component: () => import('./presentation/VideoDetailView.vue'),
      // Opened from the gallery, so it slides in over the list it was picked from.
      meta: {
        permission: Permission.VIRTUAL_PROFILER_READ,
        slidesIn: true,
        sectionNav: VP_SECTION_NAV,
      },
    },
    // The address before «Data» had its own paths; links already shared keep working.
    {
      path: 'virtual-profiler/videos/:videoId',
      redirect: (to) => ({
        name: 'virtual-profiler-video-detail',
        params: to.params,
        query: to.query,
      }),
    },
  ],
};
